// This file is automatically generated. Do not edit manually.

import { t } from "i18next";

export const ConfigurableObjectTypeValues = [
	"CUSTOMER_ORDER_LINE",
	"CUSTOMER_ORDER_OFFER_LINE",
	"PURCHASE_ORDER_LINE",
	"PROJECT_ACTIVITY_MATERIAL",
	"SHOP_ORDER_LINE",
	"SHOP_ORDER",
] as const;

export type ConfigurableObjectType = (typeof ConfigurableObjectTypeValues)[number];

export const getConfigurableObjectTypeLabels = () => ({
	CUSTOMER_ORDER_LINE: t("customer_order_line"),
	CUSTOMER_ORDER_OFFER_LINE: t("customer_order_offer_line"),
	PURCHASE_ORDER_LINE: t("purchase_order_line"),
	PROJECT_ACTIVITY_MATERIAL: t("project_activity_material"),
	SHOP_ORDER_LINE: t("shop_order_line"),
	SHOP_ORDER: t("shop_order"),
});

export const getConfigurableObjectTypeLabel = (value: ConfigurableObjectType): string => {
	return getConfigurableObjectTypeLabels()[value];
};
